import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPaperclip1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconPaperclip1"><Path d="M14 2C11.2386 2 9 4.23858 9 7V15C9 16.6569 10.3431 18 12 18C13.6569 18 15 16.6569 15 15V7H13V15C13 15.5523 12.5523 16 12 16C11.4477 16 11 15.5523 11 15V7C11 5.34315 12.3431 4 14 4C15.6569 4 17 5.34315 17 7V15C17 17.7614 14.7614 20 12 20C9.23858 20 7 17.7614 7 15V10H5V15C5 18.866 8.13401 22 12 22C15.866 22 19 18.866 19 15V7C19 4.23858 16.7614 2 14 2Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPaperclip1;
